<template>
  <Loading v-if="!fullyLoaded" />
  <PlantUserForm v-else :resource="resource" :destroy="destroy" :submit="submit" :cancel="cancel" />
</template>

<script>
import EditView from '@/mixins/editView';
import ResourceService from '@/services/resources/plant_users_service';

export default {
  mixins: [EditView],
  components: {
    PlantUserForm: () => import('@/components/forms/PlantUserForm.vue'),
  },
  data() {
    return {
      urlFragment: 'plant-users',
      resourceService: ResourceService,
    };
  },
};
</script>
